<template>
    <div class="paragraph">
        <span class="font-weight-semibold">
            <slot name="title">Title</slot>
        </span>
        <small class="text-muted d-block">
            <slot name="description"></slot>
        </small>
    </div>
</template>

<script>
export default {
    name: "ParagraphComponent"
}
</script>

<style scoped>

</style>
